/* eslint-disable complexity */
/* eslint-disable no-case-declarations */
/* eslint-disable default-case */
/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';
import {connect} from 'react-redux';
import '../../TestView/styles.scss';

import getSingleChildTestResult from 'api/getSingleChildTestResult';
import deleteSubTest from '../../../api/deleteSubtest';
import updateLogEvent from 'api/updateLogEvent';
import strings from 'utils/strings';
import getQuestionChoices from '../Utils/getQuestionChoices';

import SubtestReport from '../ScreeningNormingTest/SubtestReport';
import HandBook from '../SingleScreeningTest/HandBook';
import HorizontalBarChart from 'components/HorizontalBarChart';
import ReportIntroduction from '../ScreeningNormingTest/ReportIntroduction';

import {withRouter} from 'react-router-dom';
import TestUserInfo from './TestUserInfo';

import {
	no,
	nn,
	nonword_child_testWords,
	nonword_youth_testWords,
	nonword_adult_testWords,
} from './assets';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faLanguage, faPrint} from '@fortawesome/free-solid-svg-icons';
import {getPronoun} from 'utils/getPronouns';
import AddNotesModal from 'components/AddNotesModel';
import AlertBox from 'components/CreateNotification/alert';
import SubtestNormingReport from './Subtest';

const TESTS_REQUIRED_TO_PASS = 3;

const CHILD_FOLLOWUP_IDS = {
	arbeidsminne: 0,
	hurtigbenevning: 3,
	ettminuttesten: 4,
	spoonerism: 5,
	fonemutelatelse: 8,
	setningsminne: 10,
	nonordrepetisjon: 13,
};

const CHILD_FOLLOWUP_COMMON_THRESHOLDS = {
	[CHILD_FOLLOWUP_IDS.arbeidsminne]: -1.5,
	[CHILD_FOLLOWUP_IDS.hurtigbenevning]: -1.5,
	[CHILD_FOLLOWUP_IDS.ettminuttesten]: -1.0,
	[CHILD_FOLLOWUP_IDS.setningsminne]: -1.5,
	[CHILD_FOLLOWUP_IDS.nonordrepetisjon]: -1.5,
};

const YOUTH_FOLLOWUP_IDS = {
	arbeidsminne: 0,
	hurtigbenevning: 3,
	ettminuttesten: 4,
	spoonerism: 5,
	setningsminne: 10,
	nonordrepetisjon: 13,
};

const YOUTH_FOLLOWUP_THRESHOLDS = {
	[YOUTH_FOLLOWUP_IDS.arbeidsminne]: -1.5,
	[YOUTH_FOLLOWUP_IDS.hurtigbenevning]: -1.5,
	[YOUTH_FOLLOWUP_IDS.ettminuttesten]: -1.0,
	[YOUTH_FOLLOWUP_IDS.spoonerism]: -1.0,
	[YOUTH_FOLLOWUP_IDS.setningsminne]: -1.5,
	[YOUTH_FOLLOWUP_IDS.nonordrepetisjon]: -1.0,
};
const ADULT_FOLLOWUP_THRESHOLDS = {
	[YOUTH_FOLLOWUP_IDS.arbeidsminne]: -1.5,
	[YOUTH_FOLLOWUP_IDS.hurtigbenevning]: -1.5,
	[YOUTH_FOLLOWUP_IDS.ettminuttesten]: -1.0,
	[YOUTH_FOLLOWUP_IDS.spoonerism]: -1.0,
	[YOUTH_FOLLOWUP_IDS.setningsminne]: -1.0,
	[YOUTH_FOLLOWUP_IDS.nonordrepetisjon]: -1.0,
};

class SingleChildTest extends React.Component {
	constructor() {
		super();

		this.state = {
			showTestUserInfo: false,
			viewModes: {},
			testResult: null,
			testId: null,
			testType: null,
			isInKinderGarten: false,
			showResultsTab: true,
			// showReportTab: true,
			showInformationTab: false,
			showHandBookTab: false,
			showResultsActive: 'tablink1',
			showReportActive: 'tablink2-active',
			showInformationActive: 'tablink3',
			showHandBookActive: 'tablink4',
			birthdate: null,
			showAddNotesModal: false,
			reportNotes: '',
			showAlert: false,
			testReportLang: 'no',
			buttonTabs: [
				{
					id: 2,
					value: 'report',
					buttonClass: 'tablink2',
					text: 'Rapport',
				},
				{
					id: 'defaultOpen',
					value: 'result',
					buttonClass: 'tablink1-active',
					text: strings.results,
				},

				{
					id: 3,
					value: 'info',
					buttonClass: 'tablink3',
					text: strings.userinformation,
				},
				{
					id: 4,
					value: 'book',
					buttonClass: 'tablink4',
					text: strings.handbook,
				},
			],
		};
	}

	componentDidMount() {
		this.getTestResultAndMetadata();
	}
	formatFollowupSubtestList(items) {
		if (items.length === 1) {
			return items[0];
		}

		if (items.length === 2) {
			return `${items[0]} og ${items[1]}`;
		}

		return `${items.slice(0, -1).join(', ')} og ${items[items.length - 1]}`;
	}

	getFollowupMissingSubtestsText(
		missingIds,
		subtestNamesById,
		possessiveName,
		testReportLang
	) {
		if (!missingIds.length) {
			return null;
		}

		const missingNames = missingIds.map((id) => subtestNamesById[id]);

		const formattedNames = this.formatFollowupSubtestList(missingNames);

		const followupStrings =
			testReportLang === 'nn' ? strings._props.nn : strings;

		return strings.formatString(
			followupStrings.dldFollowupSkippedSubtestsText,
			formattedNames,
			possessiveName
		);
	}

	getTestResultAndMetadata() {
		const id = this.props.match.params.id;
		window.scrollTo(0, 0);
		getSingleChildTestResult(id).then((testResult) => {
			let isInKinderGarten = false;
			const testUser = testResult.testUser;
			const birthDate = testUser.hasOwnProperty('birthdate')
				? ` ${moment(testUser.birthdate).format('DD.MM.YYYY')}` //TODO: make brithday bold
				: '';
			if (testResult.type === 'child') {
				if (
					testResult.info.class == 0 ||
					testResult.info.class == 1 ||
					testResult.info.class == 2
				) {
					isInKinderGarten = true;
				}
			}

			testResult.subtests.map((subtest) => {
				this.setViewMode(subtest.id, 'SHOW_ANSWERED');

				return subtest;
			});

			this.setState(
				{
					testResult,
					testType: testResult.type,
					isInKinderGarten,
					birthDate,
					testId: id,
				},
				() => {
					if (
						[
							'child-followup',
							'youth-followup',
							'adult-followup',
						].includes(testResult.type)
					) {
						this.setRelevantTab('report', 0);
					}
				}
			);
		});
	}

	getLanguageAssets = (language) => {
		switch (language) {
			case 'nn':
				return nn;
			case 'no':
			default:
				return no;
		}
	};

	/* 	getQuestionChoices(question) {
		const output = {};
		for (const choice of question.choices) {
			output[choice.letter] = choice;
		}
		return output;
	} */
	updatePrintLog(action) {
		updateLogEvent('print', this.state.testId, '', action);
	}
	//more robust log
	getAnswersWithCorrectAnswer(answers, answersCorrect, questions = false) {
		const output = [];
		for (let i = 0; i < answers.length; i++) {
			let jInit = 0;
			//Saves us some looping if arrays are arranged as expected
			if (
				answers[i] &&
				answersCorrect[i] &&
				answers[i].id === answersCorrect[i].id
			) {
				jInit = i;
			}
			if (typeof answers[i].id === 'undefined') {
				break;
			}
			const currentAnswer = answers[i];
			const currentAnswerValue = currentAnswer.value.toLowerCase().trim();
			for (let j = jInit; j < answersCorrect.length; j++) {
				const currentCorrectAnswer = answersCorrect[j];
				if (currentAnswer.id === currentCorrectAnswer.id) {
					const correctAnswerValue = currentCorrectAnswer.value
						.toLowerCase()
						.trim();
					const isCorrectAnswer =
						currentAnswerValue === currentCorrectAnswer.value;

					const hasAltValues = Array.isArray(
						currentCorrectAnswer.altValues
					);
					const isCorrectAltValue =
						hasAltValues &&
						currentCorrectAnswer.altValues.indexOf(
							currentAnswerValue
						) !== -1;

					const answer = {
						id: currentAnswer.id,
						value: currentAnswerValue,
						isCorrect: isCorrectAnswer || isCorrectAltValue,
						correctValues: [correctAnswerValue],
					};

					if (hasAltValues) {
						answer.correctValues = [correctAnswerValue].concat(
							currentCorrectAnswer.altValues
						);
					}

					if (questions) {
						answer.question =
							questions[currentAnswer.id - 1].question;
						answer.choices = getQuestionChoices(
							questions[currentAnswer.id - 1]
						);
					}

					output.push(answer);
					break;
				}
			}
		}
		return output;
	}

	safelyDeleteSubtest(testId, subtestId) {
		deleteSubTest(testId, subtestId).then(() => {
			const {
				testResult: {subtests},
			} = this.state;
			if (subtests.length === 1) {
				window.location.href = '/my-tests';
			} else {
				this.getTestResultAndMetadata();
			}
		});
	}
	renderSubtestType0(key, answer, index) {
		const isAnswered = answer && answer.isAnswered === true;

		if (!isAnswered) {
			return (
				<div
					className="sub-test__answer sub-test__working-memory-unanswered"
					key={index}
				>
					<p>{key}.</p>
					<p>{strings.notanswered}</p>
				</div>
			);
		}

		const statusClass = `sub-test__answer--${
			answer.isCorrect ? 'correct' : 'wrong'
		}`;

		const statusLabel = answer.isCorrect ? strings.correct : strings.wrong;

		return (
			<div className="sub-test__answer" key={index}>
				<p>
					{key + '. '}
					<span className={statusClass}>{statusLabel}</span>
				</p>
			</div>
		);
	}
	renderRapidNamingItem(key, answer, index) {
		const isAnswered = answer && answer.isAnswered === true;

		const statusLabel = !isAnswered
			? strings.notanswered
			: answer.isCorrect
				? strings.correct
				: strings.wrong;

		const statusClass = !isAnswered
			? ''
			: `sub-test__answer--${answer.isCorrect ? 'correct' : 'wrong'}`;

		const wrapperClass = classNames('sub-test__answer', {
			'sub-test__answer--not-answered': !isAnswered,
		});

		return (
			<div className={wrapperClass} key={index}>
				<p>
					{key + '. '}
					<span className={statusClass}>{statusLabel}</span>
				</p>
			</div>
		);
	}
	renderOneMinuteItem(key, answer, index) {
		const isAnswered = answer && answer.isAnswered === true;

		const statusLabel = !isAnswered
			? strings.notanswered
			: answer.isCorrect
				? strings.correct
				: strings.wrong;

		const statusClass = !isAnswered
			? ''
			: `sub-test__answer--${answer.isCorrect ? 'correct' : 'wrong'}`;

		return (
			<div className="sub-test__answer" key={index}>
				<p>
					{key + '. '}
					<span className={statusClass}>{statusLabel}</span>
				</p>
			</div>
		);
	}
	renderSubtestType1(key, answer, index, answers) {
		const getCorrectClass = (isCorrect) => {
			return `sub-test__answer--${isCorrect ? 'correct' : 'wrong'}`;
		};

		const correctClass = getCorrectClass(answer.isCorrect);
		return (
			<div className={`sub-test__answer`} key={index}>
				<p>
					{key + '. '}
					<span className={correctClass}>{answers[index]}</span>
				</p>
			</div>
		);
	}
	renderSubtestType2(key, answer, index, answers) {
		const getCorrectClass = (isCorrect) => {
			return `sub-test__answer--${isCorrect ? 'correct' : 'wrong'}`;
		};
		const correctClass = getCorrectClass(
			answer.option === answers[index].correct
		);
		return (
			<div className={`sub-test__answer`} key={index}>
				<p>
					{key + '. '}
					<span className={correctClass}>
						{answers[index].options[answer.option]}
					</span>
				</p>
			</div>
		);
	}

	renderSubtestType3(key, answer, index, answers) {
		//orddiktat
		const getCorrectClass = (isCorrect) => {
			return `sub-test__answer--${isCorrect ? 'correct' : 'wrong'}`;
		};

		const correctClass = getCorrectClass(
			answer.toLowerCase().trim() === answers[index].toLowerCase().trim()
		);
		return (
			<div className={`sub-test__answer`} key={index}>
				<p>
					{key - 1 + '. '}
					<span className={correctClass}>{answer}</span>
				</p>
			</div>
		);
	}
	renderSubtestType4(key, answer, index, answers) {
		const getCorrectClass = (isCorrect) => {
			return `sub-test__answer--${
				isCorrect === 2
					? 'correct'
					: isCorrect === 1
						? 'halfcorrect'
						: 'wrong'
			}`;
		};

		const correctClass = getCorrectClass(answer.isCorrect);
		return (
			<div className={`sub-test__answer`} key={index}>
				<p>
					{key + '. '}
					<span className={correctClass}>{answers[index]}</span>
				</p>
			</div>
		);
	}

	renderSentenceMemoryItem(key, answer = {}, index, sentences = []) {
		const targetSentence =
			(Array.isArray(sentences) &&
				(sentences[index] || sentences[key - 1])) ||
			'';

		const mistakes =
			typeof answer.mistakes === 'number' && isFinite(answer.mistakes)
				? answer.mistakes
				: null;

		const points =
			typeof answer.points === 'number' && isFinite(answer.points)
				? answer.points
				: null;

		const isAnswered = answer.isAnswered === true;
		const pointsClass =
			points === 4
				? 'sub-test__answer--correct'
				: points === 3
					? 'sub-test__answer--score-3'
					: points === 2
						? 'sub-test__answer--score-2'
						: points === 1
							? 'sub-test__answer--score-1'
							: points === 0
								? 'sub-test__answer--wrong'
								: '';

		/* let rowClass = 'sub-test__answer--sm-zero';
		if (!isAnswered) {
			rowClass = 'sub-test__answer--unanswered';
		} else if (points >= 4) {
			rowClass = 'sub-test__answer--sm-perfect';
		} else if (points === 3) {
			rowClass = 'sub-test__answer--sm-good';
		} else if (points === 2) {
			rowClass = 'sub-test__answer--sm-ok';
		} else if (points === 1) {
			rowClass = 'sub-test__answer--sm-low';
		} */

		return (
			<div
				className="sub-test__answer sub-test__answer--sentencememory"
				key={index}
			>
				<p className="sub-test__answer__line">
					<span className="sub-test__answer__index">{key}.</span>{' '}
					{targetSentence && (
						<span className="sub-test__answer__stimulus">
							{targetSentence}{' '}
						</span>
					)}
					{isAnswered ? (
						<>
							<span className="sub-test__answer__metric">
								{strings.errorsLabel}{' '}
								<span
									style={{color: 'black'}}
									className={
										mistakes === 0
											? 'sub-test__answer--correct'
											: 'sub-test__answer--wrong'
									}
								>
									{mistakes ?? '–'}
								</span>
							</span>

							{'   '}

							<span className="sub-test__answer__metric">
								{strings.pointsLabel}{' '}
								<span className={pointsClass}>
									{points ?? '–'}
								</span>
							</span>
						</>
					) : (
						<span className="sub-test__answer__metric">
							{strings.notAnsweredCap}
						</span>
					)}
				</p>
			</div>
		);
	}

	renderNonWordRepetitionItem(key, scores = {}, index, stimuli = []) {
		const target =
			(Array.isArray(stimuli) && (stimuli[index] || stimuli[key - 1])) ||
			'';

		const {immediateScore, delayedScore, totalScore, isAnswered} = scores;
		const totalScoreClass =
			totalScore === 2
				? 'sub-test__answer--correct'
				: totalScore === 1
					? 'sub-test__answer--score-1'
					: totalScore === 0
						? 'sub-test__answer--wrong'
						: '';

		return (
			<div
				className={`sub-test__answer sub-test__answer--nonwordrepetition`}
				key={index}
			>
				<p className="sub-test__answer__line">
					<span className="sub-test__answer__index">{key}.</span>{' '}
					{target && (
						<span className="sub-test__answer__stimulus">
							{target}
						</span>
					)}
				</p>

				<p className="sub-test__answer__metrics">
					{isAnswered ? (
						<>
							<span className="sub-test__answer__metric">
								{strings.immediateLabel}{' '}
								<span
									style={{color: 'black'}}
									className={
										immediateScore === 1
											? 'sub-test__answer--correct'
											: 'sub-test__answer--wrong'
									}
								>
									{typeof immediateScore === 'number'
										? immediateScore
										: '–'}
								</span>
							</span>

							{'   '}

							<span className="sub-test__answer__metric">
								{strings.delayedLabel}{' '}
								<span
									style={{color: 'black'}}
									className={
										delayedScore === 1
											? 'sub-test__answer--correct'
											: 'sub-test__answer--wrong'
									}
								>
									{typeof delayedScore === 'number'
										? delayedScore
										: '–'}
								</span>
							</span>

							{'   '}

							<span className="sub-test__answer__metric">
								{strings.totalLabel}{' '}
								<span className={totalScoreClass}>
									{typeof totalScore === 'number'
										? totalScore
										: '–'}
								</span>
							</span>
						</>
					) : (
						<span className="sub-test__answer__metric">
							{strings.notAnsweredCap}
						</span>
					)}
				</p>
			</div>
		);
	}

	renderSubtest(subtest) {
		return (
			<SubtestNormingReport
				subtest={subtest}
				type="child"
				testType={this.state.testType} //is going to be used for better rendering of gjennomsnittig og stadaravvik skåre
				testResult={this.state.testResult} //is going to be used for rendering norms based on grade--agegroup
				isSuperAdmin={this.props.currentUser.isSuperAdmin}
				testId={this.props.match.params.id}
				resetSubtest={(testId, subtestId) => {
					this.safelyDeleteSubtest(testId, subtestId);
				}}
			>
				{this.renderAnswers(subtest)}
			</SubtestNormingReport>
		);
	}
	renderSubtestReport(subtest) {
		return (
			<SubtestReport
				subtest={subtest}
				type="child"
				testType={this.state.testType}
				testResult={this.state.testResult}
				testReportLang={this.state.testReportLang}
			/>
		);
	}

	toggleShowUnanswered(id) {
		if (this.state.viewModes[id] === 'SHOW_ALL') {
			this.setViewMode(id, 'SHOW_ANSWERED');
		} else {
			this.setViewMode(id, 'SHOW_ALL');
		}
	}

	setViewMode(id, value) {
		const obj = {};
		obj[id] = value;
		this.setState({
			viewModes: Object.assign({}, this.state.viewModes, obj),
		});
	}
	returnTestNameForId(id) {
		switch (id) {
			case 0:
				return strings.workingmemorytest;
			case 3:
				return strings.rapidautonamingtest;
			case 4:
				return strings.oneminutetest;
			case 5:
				return strings.spoonerismtest;
			case 6:
				return strings.letterknowledgetest;
			case 7:
				return strings.phonemisolationtest;
			case 8:
				return strings.phonemeomissiontest;
		}
	}
	renderAnswers(subtest) {
		const {answers} = subtest;
		let notAnswered = 0;
		let answersClass = '';
		const {viewModes} = this.state;
		let isVisible = true;
		switch (viewModes[subtest.id]) {
			case 'SHOW_ALL':
				answersClass = 'sub-test__answers--show-not-answered';
				break;
			case 'SHOW_ANSWERED':
				answersClass = '';
				break;
			case 'HIDE_ALL':
			default: {
				isVisible = false;
			}
		}

		switch (subtest.id) {
			case 0: {
				answersClass += ' sub-test__answers--working-memory';
				break;
			}

			case 1:
			case 2: {
				answersClass += ' col-2';
				break;
			}
			case 3:
			case 4:
			case 5:
			case 6:
			case 7:
			case 8: {
				answersClass += ' col-4';
				break;
			}
			case 9: {
				answersClass += ' col-3';
				break;
			}
			case 10: {
				answersClass += ' col-4 sub-test__answers--sentencememory';
				break;
			}

			case 13: {
				answersClass += ' col-3 sub-test__answers--nonwordrepetition';
				break;
			}
			default:
				break;
		}

		const languageAssets = this.getLanguageAssets(subtest.language);
		const grade = this.state.testResult.info.class;

		if (subtest.id === 10) {
			const smSource = answers && answers.test ? answers.test : {};
			const sentences = (languageAssets && languageAssets.test10) || [];

			let totalPoints = 0;
			let answeredCount = 0;
			let itemCount = 0;

			const items = Object.entries(smSource).map(
				([num, answer], index) => {
					itemCount++;
					const isAnswered = answer && answer.isAnswered === true;
					if (!isAnswered) {
						notAnswered++;
					} else {
						answeredCount++;
						const pts =
							typeof answer.points === 'number' &&
							isFinite(answer.points)
								? answer.points
								: 0;
						totalPoints += pts;
					}

					const key = index + 1;
					return this.renderSentenceMemoryItem(
						key,
						answer,
						index,
						sentences
					);
				}
			);

			if (!isVisible || !items.length) return null;

			const maxPoints = itemCount * 4;
			const answersHeading = [0, 3, 5, 10, 13, 8, 4].includes(subtest.id)
				? this.state.testType === 'adult-followup'
					? 'Kandidatens svar:'
					: 'Elevens svar:'
				: strings.candidate_answers;
			return (
				<div>
					<h4 className="sub-test__answers__heading">
						{answersHeading}
					</h4>

					<p className="sub-test__summary">
						{strings.totalColon} <b>{totalPoints}</b>{' '}
						{strings.pointsOf} <b>{maxPoints}</b>
						{itemCount > 0 && (
							<>
								{' '}
								{strings.answeredDash} <b>{answeredCount}</b>,{' '}
								{strings.unansweredColon} <b>{notAnswered}</b>
							</>
						)}
					</p>

					<div className={`sub-test__answers ${answersClass}`}>
						{items}
					</div>

					{notAnswered > 0 && (
						<p className="sub-test__not-answered">
							<b>
								{strings.formatString(
									strings.tasksNotAnswered,
									notAnswered
								)}
							</b>{' '}
							<button
								className="sub-test__link print-hide"
								onClick={(e) => {
									e.preventDefault();
									this.toggleShowUnanswered(subtest.id);
								}}
							>
								{viewModes[subtest.id] === 'SHOW_ALL'
									? strings.hideunanswered
									: strings.showunanswered}
							</button>
						</p>
					)}
				</div>
			);
		}

		if (subtest.id === 13) {
			const nwrSource = (answers && answers.test) || answers || {};

			const {testType} = this.state;
			let nwrStimuli = [];
			if (testType === 'child-followup' || testType === 'child') {
				nwrStimuli = nonword_child_testWords;
			} else if (testType === 'youth-followup') {
				nwrStimuli = nonword_youth_testWords;
			} else if (testType === 'adult-followup') {
				nwrStimuli = nonword_adult_testWords;
			}

			let totalImmediate = 0;
			let totalDelayed = 0;
			let totalOverall = 0;
			let itemCount = 0;

			const items = Object.entries(nwrSource).map(
				([num, rawAnswer], index) => {
					itemCount++;

					const immediateScore =
						rawAnswer &&
						rawAnswer.immediate &&
						typeof rawAnswer.immediate.score === 'number'
							? rawAnswer.immediate.score
							: null;

					const delayedScore =
						rawAnswer &&
						rawAnswer.delayed &&
						typeof rawAnswer.delayed.score === 'number'
							? rawAnswer.delayed.score
							: null;

					let totalScore =
						rawAnswer &&
						typeof rawAnswer.total === 'number' &&
						isFinite(rawAnswer.total)
							? rawAnswer.total
							: (immediateScore || 0) + (delayedScore || 0);

					const isAnswered =
						immediateScore !== null || delayedScore !== null;

					if (!isAnswered) {
						notAnswered++;
					} else {
						totalImmediate += immediateScore || 0;
						totalDelayed += delayedScore || 0;
						totalOverall += totalScore || 0;
					}

					const key = index + 1;
					const scores = {
						immediateScore,
						delayedScore,
						totalScore,
						isAnswered,
					};

					return this.renderNonWordRepetitionItem(
						key,
						scores,
						index,
						nwrStimuli
					);
				}
			);

			if (!isVisible || !items.length) return null;

			const maxPerPhase =
				this.state.testType === 'child-followup' ||
				this.state.testType === 'child'
					? 10
					: 12;

			const maxTotal = maxPerPhase * 2;
			const answersHeading = [0, 3, 5, 10, 13, 8, 4].includes(subtest.id)
				? this.state.testType === 'adult-followup'
					? 'Kandidatens svar:'
					: 'Elevens svar:'
				: strings.candidate_answers;
			return (
				<div>
					<h4 className="sub-test__answers__heading">
						{answersHeading}
					</h4>

					{/* ✳️ Summary line */}
					<div className="sub-test__nonword-summary">
						<p>
							{strings.immediateLabel} <b>{totalImmediate}</b> av{' '}
							<b>{maxPerPhase}</b>
						</p>

						<p>
							{strings.delayedLabel} <b>{totalDelayed}</b> av{' '}
							<b>{maxPerPhase}</b>
						</p>

						<p>
							{strings.totalLabel} <b>{totalOverall}</b> av{' '}
							<b>{maxTotal}</b>
						</p>
					</div>

					<div className={`sub-test__answers ${answersClass}`}>
						{items}
					</div>

					{notAnswered > 0 && (
						<p className="sub-test__not-answered">
							<b>
								{strings.formatString(
									strings.tasksNotAnswered,
									notAnswered
								)}
							</b>{' '}
							<button
								className="sub-test__link print-hide"
								onClick={(e) => {
									e.preventDefault();
									this.toggleShowUnanswered(subtest.id);
								}}
							>
								{viewModes[subtest.id] === 'SHOW_ALL'
									? strings.hideunanswered
									: strings.showunanswered}
							</button>
						</p>
					)}
				</div>
			);
		}

		const newAnswers = Object.entries(answers).map(
			([num, answer], index) => {
				const key = Number(num) + 1;
				switch (subtest.id) {
					case 0: {
						const sectionAnswers = Object.entries(answer);

						const correctCount = sectionAnswers.filter(
							([, currentAnswer]) =>
								currentAnswer &&
								currentAnswer.isAnswered === true &&
								currentAnswer.isCorrect === true
						).length;

						const sectionHeading =
							num === 'numbers'
								? subtest.language === 'nn'
									? 'Talrekkjer'
									: 'Tallrekker'
								: subtest.language === 'nn'
									? 'Ordrekkjer'
									: 'Ordrekker';

						const renderedItems = sectionAnswers.map(
							([num2, answer2], index2) => {
								if (!answer2 || answer2.isAnswered !== true) {
									notAnswered++;
								}

								const key2 = Number(num2) + 1;

								return this.renderSubtestType0(
									key2,
									answer2,
									index2
								);
							}
						);

						return (
							<div
								className="sub-test__working-memory-section"
								key={num}
							>
								<h5>{sectionHeading}</h5>

								<p className="sub-test__summary">
									<strong>{correctCount}</strong> av{' '}
									<strong>{sectionAnswers.length}</strong>{' '}
									riktige
								</p>

								{renderedItems}
							</div>
						);
					}
					case 3: {
						if (!answer || answer.isAnswered !== true) {
							notAnswered++;
						}

						return this.renderRapidNamingItem(key, answer, index);
					}
					case 4: {
						return this.renderOneMinuteItem(key, answer, index);
					}
					case 5: {
						const isChildSpoonerism =
							this.state.testType === 'child-followup' &&
							(Number(grade) === 6 || Number(grade) === 7);

						return this.renderSubtestType4(
							key,
							answer,
							index,
							isChildSpoonerism
								? languageAssets.test5Child
								: languageAssets.test5
						);
					}
					case 6: {
						return this.renderSubtestType1(
							key,
							answer,
							index,
							grade == 1 || grade == 0
								? languageAssets.testBH6
								: languageAssets.test6
						);
					}
					case 7: {
						return this.renderSubtestType2(
							key,
							answer,
							index,
							grade == 1 || grade == 0
								? languageAssets.testBH7
								: languageAssets.test7
						);
					}
					case 8: {
						return this.renderSubtestType1(
							key,
							answer,
							index,
							languageAssets.test8
						);
					}
					case 9: {
						return this.renderSubtestType3(
							key,
							answer,
							index,
							languageAssets.test9
						);
					}

					default:
						return '';
				}
			}
		);

		const answersHeading = [0, 3, 5, 8, 10, 13, 4].includes(subtest.id)
			? this.state.testType === 'adult-followup'
				? 'Kandidatens svar:'
				: 'Elevens svar:'
			: strings.candidate_answers;
		return (
			isVisible &&
			newAnswers.length && (
				<div>
					<h4 className="sub-test__answers__heading">
						{answersHeading}
					</h4>
					<div className={`sub-test__answers ${answersClass}`}>
						{newAnswers}
					</div>
					{subtest.id !== 0 &&
						notAnswered > 0 &&
						subtest.id !==
							10(
								<p className="sub-test__not-answered">
									<b>
										{strings.formatString(
											strings.tasksNotAnswered,
											notAnswered
										)}
									</b>{' '}
									<button
										className="sub-test__link print-hide"
										onClick={(e) => {
											e.preventDefault();
											this.toggleShowUnanswered(
												subtest.id
											);
										}}
									>
										{viewModes[subtest.id] === 'SHOW_ALL'
											? strings.hideunanswered
											: strings.showunanswered}
									</button>
								</p>
							)}
				</div>
			)
		);
	}

	getNorwegianPossessiveName(name) {
		if (!name) return '';

		const trimmedName = name.trim();

		if (/[sxz]$/i.test(trimmedName)) {
			return `${trimmedName}'`;
		}

		return `${trimmedName}s`;
	}
	getYouthFollowupScoreLevel(zScore, testReportLang) {
		if (zScore <= -2.0) {
			return testReportLang === 'nn' ? 'betydeleg' : 'betydelig';
		}

		return 'klart';
	}

	getYouthFollowupCombinedScoreLevel(
		firstScore,
		secondScore,
		testReportLang
	) {
		const firstLevel = this.getYouthFollowupScoreLevel(
			firstScore,
			testReportLang
		);

		const secondLevel = this.getYouthFollowupScoreLevel(
			secondScore,
			testReportLang
		);

		if (firstLevel === secondLevel) {
			return firstLevel;
		}

		return testReportLang === 'nn'
			? `høvesvis ${firstLevel} og ${secondLevel}`
			: `henholdsvis ${firstLevel} og ${secondLevel}`;
	}

	returnRelevantZscore(subTestsArray, testId) {
		for (let i = 0; i < subTestsArray.length; i++) {
			if (subTestsArray[i].id === testId) {
				return subTestsArray[i].zScore;
			}
		}
	}
	extractRatingDataForSubtest(subTestsArray, id) {
		for (let i = 0; i < subTestsArray.length; i++) {
			if (subTestsArray[i].id === id) {
				return subTestsArray[i].totalCorrect;
			}
		}
	}
	getDldChildFollowupWriteUpText(
		testResult,
		subtestsToBeRendered,
		testReportLang
	) {
		const grade = Number(testResult.testUser?.class);

		const isGrade2To5 = grade >= 2 && grade <= 5;
		const isGrade6To7 = grade >= 6 && grade <= 7;

		if (!isGrade2To5 && !isGrade6To7) {
			return null;
		}

		const ids = CHILD_FOLLOWUP_IDS;

		const phonologicalId = isGrade2To5
			? ids.fonemutelatelse
			: ids.spoonerism;

		const thresholds = {
			...CHILD_FOLLOWUP_COMMON_THRESHOLDS,
			[phonologicalId]: -1.0,
		};

		const requiredIds = [
			ids.arbeidsminne,
			ids.hurtigbenevning,
			ids.ettminuttesten,
			phonologicalId,
			ids.setningsminne,
			ids.nonordrepetisjon,
		];

		const scoresById = {};

		(subtestsToBeRendered || []).forEach((subtest) => {
			if (!subtest) {
				return;
			}

			const rawScore = subtest.zScore;

			if (
				rawScore === null ||
				typeof rawScore === 'undefined' ||
				rawScore === ''
			) {
				return;
			}

			const score = Number(rawScore);

			if (!isNaN(score)) {
				scoresById[subtest.id] = score;
			}
		});

		if (!testResult.completedAt) {
			return [];
		}

		const hasScore = (id) =>
			Object.prototype.hasOwnProperty.call(scoresById, id);

		const missingIds = requiredIds.filter((id) => !hasScore(id));

		const hasAnyRequiredScores = requiredIds.some((id) => hasScore(id));

		const isLow = (id) => hasScore(id) && scoresById[id] <= thresholds[id];

		const testUser = testResult.testUser || {};

		const firstName = testUser.firstName
			? testUser.firstName
			: '<skjult navn>';

		const possessiveName = testUser.firstName
			? this.getNorwegianPossessiveName(testUser.firstName)
			: testReportLang === 'nn'
				? 'eleven sine'
				: 'elevens';

		const singularPossessiveName = testUser.firstName
			? this.getNorwegianPossessiveName(testUser.firstName)
			: testReportLang === 'nn'
				? 'eleven si'
				: 'elevens';
		const subtestNamesById = {
			[ids.arbeidsminne]: 'Arbeidsminne',
			[ids.hurtigbenevning]: 'Hurtigbenevning',
			[ids.ettminuttesten]: 'Ettminuttstesten',
			[ids.spoonerism]: 'Spoonerism',
			[ids.fonemutelatelse]: 'Fonemutelatelse',
			[ids.setningsminne]: 'Setningsminne',
			[ids.nonordrepetisjon]: 'Nonordrepetisjon',
		};
		const workingMemoryLow = isLow(ids.arbeidsminne);

		const rapidNamingLow = isLow(ids.hurtigbenevning);

		const minuteLow = isLow(ids.ettminuttesten);

		const phonologicalLow = isLow(phonologicalId);

		const sentenceMemoryLow = isLow(ids.setningsminne);

		const nonwordRepetitionLow = isLow(ids.nonordrepetisjon);

		const childFollowupStrings =
			testReportLang === 'nn' ? strings._props.nn : strings;

		const childFollowupTexts = isGrade2To5
			? {
					text1: childFollowupStrings.dldChildFollowupGrade2To5Text1,
					text2: childFollowupStrings.dldChildFollowupGrade2To5Text2,
					text3: childFollowupStrings.dldChildFollowupGrade2To5Text3,
					text4: childFollowupStrings.dldChildFollowupGrade2To5Text4,
					text5: childFollowupStrings.dldChildFollowupGrade2To5Text5,
					text6: childFollowupStrings.dldChildFollowupGrade2To5Text6,
					text7: childFollowupStrings.dldChildFollowupGrade2To5Text7,
					text8: childFollowupStrings.dldChildFollowupGrade2To5Text8,
					text9: childFollowupStrings.dldChildFollowupGrade2To5Text9,
					text10: childFollowupStrings.dldChildFollowupGrade2To5Text10,
				}
			: {
					text1: childFollowupStrings.dldChildFollowupGrade6To7Text1,
					text2: childFollowupStrings.dldChildFollowupGrade6To7Text2,
					text3: childFollowupStrings.dldChildFollowupGrade6To7Text3,
					text4: childFollowupStrings.dldChildFollowupGrade6To7Text4,
					text5: childFollowupStrings.dldChildFollowupGrade6To7Text5,
					text6: childFollowupStrings.dldChildFollowupGrade6To7Text6,
					text7: childFollowupStrings.dldChildFollowupGrade6To7Text7,
					text8: childFollowupStrings.dldChildFollowupGrade6To7Text8,
					text9: childFollowupStrings.dldChildFollowupGrade6To7Text9,
					text10: childFollowupStrings.dldChildFollowupGrade6To7Text10,
				};

		const writeUpText = [];

		/*
		 * Dyslexia markers:
		 * Text 3 replaces Text 1 + Text 2.
		 */
		if (minuteLow && phonologicalLow) {
			writeUpText.push(
				strings.formatString(
					childFollowupTexts.text3,
					firstName,
					this.getYouthFollowupCombinedScoreLevel(
						scoresById[ids.ettminuttesten],
						scoresById[phonologicalId],
						testReportLang
					)
				)
			);
		} else if (minuteLow) {
			writeUpText.push(
				strings.formatString(
					childFollowupTexts.text1,
					firstName,
					this.getYouthFollowupScoreLevel(
						scoresById[ids.ettminuttesten],
						testReportLang
					)
				)
			);
		} else if (phonologicalLow) {
			writeUpText.push(
				strings.formatString(
					childFollowupTexts.text2,
					firstName,
					this.getYouthFollowupScoreLevel(
						scoresById[phonologicalId],
						testReportLang
					)
				)
			);
		}

		/*
		 * DLD markers:
		 * Text 8 replaces Text 6 + Text 7.
		 */
		if (sentenceMemoryLow && nonwordRepetitionLow) {
			writeUpText.push(
				strings.formatString(
					childFollowupTexts.text8,
					firstName,
					this.getYouthFollowupCombinedScoreLevel(
						scoresById[ids.setningsminne],
						scoresById[ids.nonordrepetisjon],
						testReportLang
					)
				)
			);
		} else if (sentenceMemoryLow) {
			writeUpText.push(
				strings.formatString(
					childFollowupTexts.text6,
					firstName,
					this.getYouthFollowupScoreLevel(
						scoresById[ids.setningsminne],
						testReportLang
					)
				)
			);
		} else if (nonwordRepetitionLow) {
			writeUpText.push(
				strings.formatString(
					childFollowupTexts.text7,
					firstName,
					this.getYouthFollowupScoreLevel(
						scoresById[ids.nonordrepetisjon],
						testReportLang
					)
				)
			);
		}

		/*
		 * Department requested these after the
		 * dyslexia/DLD-specific paragraphs.
		 */
		if (workingMemoryLow) {
			writeUpText.push(
				strings.formatString(
					childFollowupTexts.text4,
					firstName,
					this.getYouthFollowupScoreLevel(
						scoresById[ids.arbeidsminne],
						testReportLang
					),
					singularPossessiveName
				)
			);
		}

		if (rapidNamingLow) {
			writeUpText.push(
				strings.formatString(
					childFollowupTexts.text5,
					firstName,
					this.getYouthFollowupScoreLevel(
						scoresById[ids.hurtigbenevning],
						testReportLang
					)
				)
			);
		}

		/*
		 * Text 10 is shown when the completed subtests
		 * contain no low scores.
		 *
		 * If every required subtest was skipped, do not
		 * claim that there were no indications.
		 */
		if (writeUpText.length === 0 && hasAnyRequiredScores) {
			writeUpText.push(
				strings.formatString(childFollowupTexts.text10, firstName)
			);
		}

		/*
		 * Inform the reader about skipped subtests.
		 */
		const missingSubtestsText = this.getFollowupMissingSubtestsText(
			missingIds,
			subtestNamesById,
			possessiveName,
			testReportLang
		);

		if (missingSubtestsText) {
			writeUpText.push(missingSubtestsText);
		}

		/*
		 * Text 9 is additive and must remain the final
		 * assessment paragraph.
		 */
		const hasDyslexiaMarker = minuteLow || phonologicalLow;

		const hasDldMarker = sentenceMemoryLow || nonwordRepetitionLow;

		if (hasDyslexiaMarker && hasDldMarker) {
			writeUpText.push(childFollowupTexts.text9);
		}

		return writeUpText;
	}

	getDldYouthFollowupWriteUpText(
		testResult,
		subtestsToBeRendered,
		testReportLang
	) {
		const youthFollowupStrings =
			testReportLang === 'nn' ? strings._props.nn : strings;
		const ids = YOUTH_FOLLOWUP_IDS;
		const scoresById = {};

		(subtestsToBeRendered || []).forEach((subtest) => {
			if (!subtest) return;

			const rawScore = subtest.zScore;

			if (
				rawScore === null ||
				typeof rawScore === 'undefined' ||
				rawScore === ''
			) {
				return;
			}

			const score = Number(rawScore);

			if (!isNaN(score)) {
				scoresById[subtest.id] = score;
			}
		});

		const requiredIds = Object.values(ids);

		if (!testResult.completedAt) {
			return [];
		}

		const hasScore = (id) =>
			Object.prototype.hasOwnProperty.call(scoresById, id);

		const missingIds = requiredIds.filter((id) => !hasScore(id));

		const hasAnyRequiredScores = requiredIds.some((id) => hasScore(id));

		const isLow = (id) =>
			hasScore(id) && scoresById[id] <= YOUTH_FOLLOWUP_THRESHOLDS[id];

		const testUser = testResult.testUser || {};
		console.log('YOUTH FOLLOWUP testUser:', testUser);
		console.log('firstName:', testUser.firstName);
		console.log('lastName:', testUser.lastName);

		const firstName = testUser.firstName
			? testUser.firstName
			: '<skjult navn>';

		const possessiveName = testUser.firstName
			? this.getNorwegianPossessiveName(testUser.firstName)
			: 'kandidatens';
		const subtestNamesById = {
			[ids.arbeidsminne]: 'Arbeidsminne',
			[ids.hurtigbenevning]: 'Hurtigbenevning',
			[ids.ettminuttesten]: 'Ettminuttstesten',
			[ids.spoonerism]: 'Spoonerism',
			[ids.setningsminne]: 'Setningsminne',
			[ids.nonordrepetisjon]: 'Nonordrepetisjon',
		};
		const workingMemoryLow = isLow(ids.arbeidsminne);
		const rapidNamingLow = isLow(ids.hurtigbenevning);
		const minuteLow = isLow(ids.ettminuttesten);
		const spoonerismLow = isLow(ids.spoonerism);
		const sentenceMemoryLow = isLow(ids.setningsminne);
		const nonwordRepetitionLow = isLow(ids.nonordrepetisjon);

		const writeUpText = [];

		if (minuteLow && spoonerismLow) {
			writeUpText.push(
				strings.formatString(
					youthFollowupStrings.dldYouthFollowupText3,
					firstName,
					this.getYouthFollowupCombinedScoreLevel(
						scoresById[ids.ettminuttesten],
						scoresById[ids.spoonerism],
						testReportLang
					)
				)
			);
		} else if (minuteLow) {
			writeUpText.push(
				strings.formatString(
					youthFollowupStrings.dldYouthFollowupText1,
					firstName,
					this.getYouthFollowupScoreLevel(
						scoresById[ids.ettminuttesten],
						testReportLang
					)
				)
			);
		} else if (spoonerismLow) {
			writeUpText.push(
				strings.formatString(
					youthFollowupStrings.dldYouthFollowupText2,
					firstName,
					this.getYouthFollowupScoreLevel(
						scoresById[ids.spoonerism],
						testReportLang
					)
				)
			);
		}

		if (sentenceMemoryLow && nonwordRepetitionLow) {
			writeUpText.push(
				strings.formatString(
					youthFollowupStrings.dldYouthFollowupText8,
					firstName,
					this.getYouthFollowupCombinedScoreLevel(
						scoresById[ids.setningsminne],
						scoresById[ids.nonordrepetisjon],
						testReportLang
					)
				)
			);
		} else if (sentenceMemoryLow) {
			writeUpText.push(
				strings.formatString(
					youthFollowupStrings.dldYouthFollowupText6,
					firstName,
					this.getYouthFollowupScoreLevel(
						scoresById[ids.setningsminne],
						testReportLang
					)
				)
			);
		} else if (nonwordRepetitionLow) {
			writeUpText.push(
				strings.formatString(
					youthFollowupStrings.dldYouthFollowupText7,
					firstName,
					this.getYouthFollowupScoreLevel(
						scoresById[ids.nonordrepetisjon],
						testReportLang
					)
				)
			);
		}

		if (workingMemoryLow) {
			writeUpText.push(
				strings.formatString(
					youthFollowupStrings.dldYouthFollowupText4,
					firstName,
					this.getYouthFollowupScoreLevel(
						scoresById[ids.arbeidsminne],
						testReportLang
					),
					possessiveName
				)
			);
		}

		if (rapidNamingLow) {
			writeUpText.push(
				strings.formatString(
					youthFollowupStrings.dldYouthFollowupText5,
					firstName,
					this.getYouthFollowupScoreLevel(
						scoresById[ids.hurtigbenevning],
						testReportLang
					)
				)
			);
		}

		if (writeUpText.length === 0 && hasAnyRequiredScores) {
			writeUpText.push(
				strings.formatString(
					youthFollowupStrings.dldYouthFollowupText10,
					firstName
				)
			);
		}

		const missingSubtestsText = this.getFollowupMissingSubtestsText(
			missingIds,
			subtestNamesById,
			possessiveName,
			testReportLang
		);

		if (missingSubtestsText) {
			writeUpText.push(missingSubtestsText);
		}

		const hasDyslexiaMarker = minuteLow || spoonerismLow;

		const hasDldMarker = sentenceMemoryLow || nonwordRepetitionLow;

		if (hasDyslexiaMarker && hasDldMarker) {
			writeUpText.push(youthFollowupStrings.dldYouthFollowupText9);
		}

		return writeUpText;
	}
	getDldAdultFollowupWriteUpText(
		testResult,
		subtestsToBeRendered,
		testReportLang
	) {
		const adultFollowupStrings =
			testReportLang === 'nn' ? strings._props.nn : strings;

		const ids = YOUTH_FOLLOWUP_IDS;
		const scoresById = {};

		(subtestsToBeRendered || []).forEach((subtest) => {
			if (!subtest) return;

			const rawScore = subtest.zScore;

			if (
				rawScore === null ||
				typeof rawScore === 'undefined' ||
				rawScore === ''
			) {
				return;
			}

			const score = Number(rawScore);

			if (!isNaN(score)) {
				scoresById[subtest.id] = score;
			}
		});

		const requiredIds = Object.values(ids);

		if (!testResult.completedAt) {
			return [];
		}

		const hasScore = (id) =>
			Object.prototype.hasOwnProperty.call(scoresById, id);

		const missingIds = requiredIds.filter((id) => !hasScore(id));

		const hasAnyRequiredScores = requiredIds.some((id) => hasScore(id));

		const isLow = (id) =>
			hasScore(id) && scoresById[id] <= ADULT_FOLLOWUP_THRESHOLDS[id];

		const testUser = testResult.testUser || {};

		const firstName = testUser.firstName
			? testUser.firstName
			: '<skjult navn>';

		const possessiveName = testUser.firstName
			? this.getNorwegianPossessiveName(testUser.firstName)
			: 'kandidatens';
		const subtestNamesById = {
			[ids.arbeidsminne]: 'Arbeidsminne',
			[ids.hurtigbenevning]: 'Hurtigbenevning',
			[ids.ettminuttesten]: 'Ettminuttstesten',
			[ids.spoonerism]: 'Spoonerism',
			[ids.setningsminne]: 'Setningsminne',
			[ids.nonordrepetisjon]: 'Nonordrepetisjon',
		};
		const workingMemoryLow = isLow(ids.arbeidsminne);
		const rapidNamingLow = isLow(ids.hurtigbenevning);
		const minuteLow = isLow(ids.ettminuttesten);
		const spoonerismLow = isLow(ids.spoonerism);
		const sentenceMemoryLow = isLow(ids.setningsminne);
		const nonwordRepetitionLow = isLow(ids.nonordrepetisjon);

		const writeUpText = [];

		if (minuteLow && spoonerismLow) {
			writeUpText.push(
				strings.formatString(
					adultFollowupStrings.dldAdultFollowupText3,
					firstName,
					this.getYouthFollowupCombinedScoreLevel(
						scoresById[ids.ettminuttesten],
						scoresById[ids.spoonerism],
						testReportLang
					)
				)
			);
		} else if (minuteLow) {
			writeUpText.push(
				strings.formatString(
					adultFollowupStrings.dldAdultFollowupText1,
					firstName,
					this.getYouthFollowupScoreLevel(
						scoresById[ids.ettminuttesten],
						testReportLang
					)
				)
			);
		} else if (spoonerismLow) {
			writeUpText.push(
				strings.formatString(
					adultFollowupStrings.dldAdultFollowupText2,
					firstName,
					this.getYouthFollowupScoreLevel(scoresById[ids.spoonerism]),
					testReportLang
				)
			);
		}

		if (sentenceMemoryLow && nonwordRepetitionLow) {
			writeUpText.push(
				strings.formatString(
					adultFollowupStrings.dldAdultFollowupText8,
					firstName,
					this.getYouthFollowupCombinedScoreLevel(
						scoresById[ids.setningsminne],
						scoresById[ids.nonordrepetisjon],
						testReportLang
					)
				)
			);
		} else if (sentenceMemoryLow) {
			writeUpText.push(
				strings.formatString(
					adultFollowupStrings.dldAdultFollowupText6,
					firstName,
					this.getYouthFollowupScoreLevel(
						scoresById[ids.setningsminne],
						testReportLang
					)
				)
			);
		} else if (nonwordRepetitionLow) {
			writeUpText.push(
				strings.formatString(
					adultFollowupStrings.dldAdultFollowupText7,
					firstName,
					this.getYouthFollowupScoreLevel(
						scoresById[ids.nonordrepetisjon],
						testReportLang
					)
				)
			);
		}

		if (workingMemoryLow) {
			writeUpText.push(
				strings.formatString(
					adultFollowupStrings.dldAdultFollowupText4,
					firstName,
					this.getYouthFollowupScoreLevel(
						scoresById[ids.arbeidsminne],
						testReportLang
					),
					possessiveName
				)
			);
		}

		if (rapidNamingLow) {
			writeUpText.push(
				strings.formatString(
					adultFollowupStrings.dldAdultFollowupText5,
					firstName,
					this.getYouthFollowupScoreLevel(
						scoresById[ids.hurtigbenevning],
						testReportLang
					)
				)
			);
		}

		if (writeUpText.length === 0 && hasAnyRequiredScores) {
			writeUpText.push(
				strings.formatString(
					adultFollowupStrings.dldAdultFollowupText10,
					firstName
				)
			);
		}

		const missingSubtestsText = this.getFollowupMissingSubtestsText(
			missingIds,
			subtestNamesById,
			possessiveName,
			testReportLang
		);

		if (missingSubtestsText) {
			writeUpText.push(missingSubtestsText);
		}

		const hasDyslexiaMarker = minuteLow || spoonerismLow;

		const hasDldMarker = sentenceMemoryLow || nonwordRepetitionLow;

		if (hasDyslexiaMarker && hasDldMarker) {
			writeUpText.push(adultFollowupStrings.dldAdultFollowupText9);
		}

		return writeUpText;
	}

	assembleAsessment(
		scenario,
		lowScoredSubTests,
		writeUpText,
		completeName,
		subtestsToBeRendered,
		testUser
	) {
		const [{language}] = subtestsToBeRendered;
		const {testReportLang} = this.state;

		const workingmemorylowassesment =
			testReportLang === 'nn'
				? strings._props.nn.workingmemorylowassesment
				: strings.workingmemorylowassesment;
		const rapidnominationlowassesment =
			testReportLang === 'nn'
				? strings._props.nn.rapidnominationlowassesment
				: strings.rapidnominationlowassesment;
		const oneminutelowassesment =
			testReportLang === 'nn'
				? strings._props.nn.oneminutelowassesment
				: strings.oneminutelowassesment;
		const oneminutelowassesment2 =
			testReportLang === 'nn'
				? strings._props.nn.oneminutelowassesment2
				: strings.oneminutelowassesment2;
		const spoonerismlowassesment =
			testReportLang === 'nn'
				? strings._props.nn.spoonerismlowassesment
				: strings.spoonerismlowassesment;
		const fonemutelatelselowassesment =
			testReportLang === 'nn'
				? strings._props.nn.fonemutelatelselowassesment
				: strings.fonemutelatelselowassesment;
		const assessmentokBHtest =
			testReportLang === 'nn'
				? strings._props.nn.assessmentokBHtest
				: strings.assessmentokBHtest;
		const assessmentBHonlyLK =
			testReportLang === 'nn'
				? strings._props.nn.assessmentBHonlyLK
				: strings.assessmentBHonlyLK;
		const assessmentBHRI =
			testReportLang === 'nn'
				? strings._props.nn.assessmentBHRI
				: strings.assessmentBHRI;
		const assessmentBHWM =
			testReportLang === 'nn'
				? strings._props.nn.assessmentBHWM
				: strings.assessmentBHWM;
		const assessmentBHFI =
			testReportLang === 'nn'
				? strings._props.nn.assessmentBHFI
				: strings.assessmentBHFI;
		const assessmentBHFU =
			testReportLang === 'nn'
				? strings._props.nn.assessmentBHFU
				: strings.assessmentBHFU;

		switch (scenario) {
			case 'lowBH':
				if (
					lowScoredSubTests.length === 1 &&
					lowScoredSubTests[0] === strings.letterknowledgetest
				) {
					writeUpText.push(
						strings.formatString(
							assessmentBHonlyLK,
							`${completeName}`
						)
					);
					writeUpText.push(
						strings.formatString(
							assessmentokBHtest,
							`${completeName}`
						)
					);
				} else {
					for (let i = 0; i < lowScoredSubTests.length; i++) {
						switch (lowScoredSubTests[i]) {
							case strings.letterknowledgetest:
								writeUpText.push(
									strings.formatString(
										assessmentBHonlyLK,
										`${completeName}`
									)
								);
								break;

							case strings.workingmemorytest:
								writeUpText.push(
									strings.formatString(
										assessmentBHWM,
										`${completeName}`,
										`${this.returnRelevantZscore(
											subtestsToBeRendered,
											0
										)}`,
										`${completeName}`
									)
								);
								break;
							case strings.phonemisolationtest:
								writeUpText.push(
									strings.formatString(
										assessmentBHFI,
										completeName,
										this.returnRelevantZscore(
											subtestsToBeRendered,
											7
										)
									)
								);
								break;

							case strings.phonemeomissiontest:
								writeUpText.push(
									strings.formatString(
										assessmentBHFU,
										completeName,
										this.returnRelevantZscore(
											subtestsToBeRendered,
											8
										)
									)
								);
								break;

							case strings.rapidautonamingtest:
								writeUpText.push(
									strings.formatString(
										assessmentBHRI,
										completeName,
										this.returnRelevantZscore(
											subtestsToBeRendered,
											3
										)
									)
								);
								break;
							case strings.oneminutetest:
								const totalCorrect =
									this.extractRatingDataForSubtest(
										subtestsToBeRendered,
										4
									);
								let zScore;
								if (totalCorrect < 62) {
									zScore =
										` < ` +
										this.returnRelevantZscore(
											subtestsToBeRendered,
											4
										);
								} else if (totalCorrect > 61) {
									zScore =
										` > ` +
										this.returnRelevantZscore(
											subtestsToBeRendered,
											4
										);
								} else if (
									totalCorrect < 115 &&
									totalCorrect > 62
								) {
									zScore = this.returnRelevantZscore(
										subtestsToBeRendered,
										4
									);
								}
								writeUpText.push(
									strings.formatString(
										oneminutelowassesment,
										completeName,
										zScore || 0
									)
								);
								writeUpText.push(oneminutelowassesment2);
								break;
						}
					}
				}

				break;
			case 'lowFollowup':
				for (let i = 0; i < lowScoredSubTests.length; i++) {
					switch (lowScoredSubTests[i]) {
						case strings.workingmemorytest:
							writeUpText.push(
								strings.formatString(
									workingmemorylowassesment,
									`${completeName}`,
									`${this.returnRelevantZscore(
										subtestsToBeRendered,
										0
									)}`,
									`${getPronoun(testUser.gender, language)}`
								)
							);
							break;
						case strings.rapidautonamingtest:
							writeUpText.push(
								strings.formatString(
									rapidnominationlowassesment,
									completeName,
									this.returnRelevantZscore(
										subtestsToBeRendered,
										3
									)
								)
							);
							break;
						case strings.oneminutetest:
							let zScore;

							zScore = this.returnRelevantZscore(
								subtestsToBeRendered,
								4
							);

							writeUpText.push(
								strings.formatString(
									oneminutelowassesment,
									completeName,
									zScore || 0
								)
							);
							writeUpText.push(oneminutelowassesment2);
							break;
						case strings.spoonerismtest:
							writeUpText.push(
								strings.formatString(
									spoonerismlowassesment,
									completeName,
									this.returnRelevantZscore(
										subtestsToBeRendered,
										5
									)
								)
							);
							break;
						case strings.fonemutelatelsetest:
							writeUpText.push(
								strings.formatString(
									fonemutelatelselowassesment,
									completeName,
									this.returnRelevantZscore(
										subtestsToBeRendered,
										8
									)
								)
							);
							break;
					}
				}
				break;
		}
	}
	returnTestUserGrade(testUser, notAvailable) {
		let testUserGrade = null;

		if (
			['child-followup', 'youth-followup'].includes(this.state.testType)
		) {
			testUserGrade = (
				<>
					<br />
					{`${testUser.class}.${strings.grade}`}
					<br />
				</>
			);
		} else if (testUser.hasOwnProperty('class')) {
			const highestCompletedEducation = testUser.class
				? testUser.class
				: notAvailable;

			testUserGrade = (
				<>
					<br />
					{`${strings.education}: ${highestCompletedEducation}`}
					<br />
				</>
			);
		}
		return testUserGrade;
	}

	setRelevantTab(key, index) {
		const {buttonTabs} = this.state;
		for (let i = 0; i < buttonTabs.length; i++) {
			if (
				i === index &&
				!buttonTabs[index].buttonClass.includes('active')
			) {
				const counter = index + 1;
				buttonTabs[index].buttonClass = `tablink${counter}-active`;
			} else {
				const counter = i + 1;
				buttonTabs[i].buttonClass = `tablink${counter}`;
			}
		}
		switch (key) {
			case 'result':
				this.setState({
					showResultsTab: true,
					showReportTab: false,
					showInformationTab: false,
					showTestUserInfo: false,
					showHandBookTab: false,

					buttonTabs,
				});
				break;
			case 'report':
				this.setState({
					showResultsTab: false,
					showReportTab: true,
					showInformationTab: true,
					showTestUserInfo: false,
					showHandBookTab: false,

					showHandBookActive: 'tablink4',
					buttonTabs,
				});
				break;
			case 'info':
				this.setState({
					showResultsTab: false,
					showReportTab: true,
					showInformationTab: false,
					showTestUserInfo: true,
					showHandBookTab: false,

					buttonTabs,
				});
				break;
			case 'book':
				this.setState({
					showResultsTab: false,
					showReportTab: false,
					showInformationTab: false,
					showHandBookTab: true,
					showTestUserInfo: false,
					buttonTabs,
				});
				break;
		}
	}
	toggleAddNotesModal = () => {
		this.setState({showAddNotesModal: !this.state.showAddNotesModal});
	};
	onClickTranslateReport = () => {
		const {
			testResult: {
				subtests: [{language}],
			},
			testReportLang,
		} = this.state;
		let translateTo = 'nn';
		if (testReportLang === 'nn') {
			translateTo = 'no';
		}
		this.setState({testReportLang: translateTo});
	};
	// eslint-disable-next-line complexity
	render() {
		const {
			showTestUserInfo,
			testResult,
			testType,
			isInKinderGarten,
			birthDate,
			reportNotes,
			testReportLang,
		} = this.state;

		if (!testResult) {
			return null;
		}

		const {testUser} = testResult;
		console.log('testResult', testResult);
		const {
			testResult: {
				subtests: [{language}],
			},
		} = this.state;
		const asessmenttextok1 =
			testReportLang === 'nn'
				? strings._props.nn.asessmenttextok_1
				: strings.asessmenttextok_1;
		const asessmenttextnotok1 =
			testReportLang === 'nn'
				? strings._props.nn.asessmenttextnotok_1
				: strings.asessmenttextnotok_1;
		const assesmenttextokYouthfollowup =
			testReportLang === 'nn'
				? strings._props.nn.assesmenttextok_youthfollowup
				: strings.assesmenttextok_youthfollowup;
		const assesmentokRecommendationYouthfollowup =
			testReportLang === 'nn'
				? strings._props.nn.assesmentok_recommendation_youthfollowup
				: strings.assesmentok_recommendation_youthfollowup;
		const assessmentokBHtest =
			testReportLang === 'nn'
				? strings._props.nn.assessmentokBHtest
				: strings.assessmentokBHtest;
		const zscorered =
			testReportLang === 'nn'
				? strings._props.nn.zscorered
				: strings.zscorered;
		const zscoregreen =
			testReportLang === 'nn'
				? strings._props.nn.zscoregreen
				: strings.zscoregreen;
		const zscoreblue =
			testReportLang === 'nn'
				? strings._props.nn.zscoreblue
				: strings.zscoreblue;
		const newinfo2BelowpresentsInformation =
			testReportLang === 'nn'
				? strings._props.nn.newinfo2_belowpresentsinformation
				: strings.newinfo2_belowpresentsinformation;
		const notAvailable =
			testReportLang === 'nn'
				? strings._props.nn.notavailable
				: strings.notavailable;
		const infoTestWasCompletedOn =
			testReportLang === 'nn'
				? strings._props.nn.info_testwascompletedon
				: strings.info_testwascompletedon;
		const inforScrAgeAtCommencement =
			testReportLang === 'nn'
				? strings._props.nn.infor_scr_ageAtCommencement
				: strings.infor_scr_ageAtCommencement;
		const {
			currentUser: {
				firstName: adminFirstName = '',
				lastName: adminLastName = '',
			} = {},
		} = this.props;

		const adminCompleteName = `${adminFirstName} ${adminLastName}`;
		const ownerFullName = testResult.adminFullName
			? testResult.adminFullName
			: language === 'nn'
				? '<Ikkje tilgjengeleg>'
				: '<Ikke tilgjengelig>';
		const isCommon = adminCompleteName === ownerFullName;
		const subtestsToBeRendered = testResult.subtests.filter((subtest) => {
			const hasZero =
				testResult.subtests.filter((subtest2) => subtest2.id === 0)
					.length > 0;
			if ([1, 2].includes(subtest.id)) {
				return !hasZero;
			}
			return true;
		});
		const subtestsLength = subtestsToBeRendered.length;
		let zScoreLowCount = 0;
		let lowScoredSubTests = [];
		subtestsToBeRendered.forEach((subtest) => {
			if (subtest.zScore <= -1) {
				lowScoredSubTests.push(this.returnTestNameForId(subtest.id));
				zScoreLowCount++;
			}
		});
		let completeName = '<skjult navn>';
		if (testUser.firstName) {
			completeName = `${testUser.firstName} ${testUser.lastName}`;
		}

		const languageStatus =
			String(testUser.hasHomeLanguageOtherThanNorwegian) === '1'
				? 'Norsk som andrespråk'
				: String(testUser.hasHomeLanguageOtherThanNorwegian) === '0'
					? 'Norsk som førstespråk'
					: notAvailable;
		let writeUpText = [];
		if (isInKinderGarten) {
			if (!lowScoredSubTests.length) {
				writeUpText.push(
					strings.formatString(assessmentokBHtest, `${completeName}`)
				);
			} else if (lowScoredSubTests.length) {
				this.assembleAsessment(
					'lowBH',
					lowScoredSubTests,
					writeUpText,
					completeName,
					subtestsToBeRendered,
					testUser
				);
			}
		} else if (['child'].includes(testType) && !isInKinderGarten) {
			if (zScoreLowCount >= TESTS_REQUIRED_TO_PASS) {
				writeUpText.push(
					strings.formatString(
						asessmenttextnotok1,
						`${completeName}`,
						`${zScoreLowCount}`,
						`${subtestsLength}`
					)
				);
			} else if (zScoreLowCount < TESTS_REQUIRED_TO_PASS) {
				writeUpText.push(
					strings.formatString(
						asessmenttextok1,
						`${completeName}`,
						`${subtestsLength - zScoreLowCount}`
					)
				);
			}
		} else if (testType === 'youth-followup') {
			writeUpText = this.getDldYouthFollowupWriteUpText(
				testResult,
				subtestsToBeRendered,
				this.state.testReportLang
			);
		} else if (testType === 'adult-followup') {
			writeUpText = this.getDldAdultFollowupWriteUpText(
				testResult,
				subtestsToBeRendered,
				this.state.testReportLang
			);
		} else if (testType === 'child-followup') {
			const childGrade = Number(testResult.testUser?.class);

			const useNewChildFollowup = childGrade >= 2 && childGrade <= 7;

			if (useNewChildFollowup) {
				writeUpText = this.getDldChildFollowupWriteUpText(
					testResult,
					subtestsToBeRendered,
					testReportLang
				);
			} else if (!lowScoredSubTests.length) {
				writeUpText.push(
					strings.formatString(
						assesmenttextokYouthfollowup,
						`${completeName}`
					)
				);

				writeUpText.push(
					strings.formatString(
						assesmentokRecommendationYouthfollowup,
						completeName
					)
				);
			} else {
				this.assembleAsessment(
					'lowFollowup',
					lowScoredSubTests,
					writeUpText,
					completeName,
					subtestsToBeRendered,
					testUser
				);
			}
		}

		return (
			<div className="lit-single-test">
				<div>
					<div
						className={
							this.state.testType === 'child'
								? 'lit-single-youthtest-title-desc'
								: 'lit-single-adulttest-title-desc'
						}
					>
						<h1 className="lit-page-title">
							{this.state.showHandBookTab
								? strings.formatString(
										strings.handbooktitle,
										<>
											<b>{strings.handbook}</b>
											<br />
											<br />
										</>
									)
								: this.state.showResultsTab
									? strings.formatString(
											strings.dynamicheaderfortestresult_child,
											this.state.testType === 'child' ? (
												<>
													<br />
													<br />
													<b>
														{
															strings.childfollowuptest
														}
													</b>
												</>
											) : this.state.testType ===
											  'youth-followup' ? (
												<>
													<b>
														<br />
														<br />
														{
															strings.youthfollowuptest
														}
													</b>
												</>
											) : this.state.testType ===
											  'child-followup' ? (
												<b>
													<br />
													<br />
													{strings.childfollowuptest}
												</b>
											) : (
												<>
													<br />
													<br />
													<b>
														{
															strings.adultfollowuptest
														}
													</b>
												</>
											)
										)
									: this.state.showTestUserInfo
										? strings.formatString(
												strings.dynamicheaderfortestcandidate_child,
												this.state.testType ===
													'child' ? (
													<>
														<br />
														<b>
															{strings.childtest}
														</b>
													</>
												) : this.state.testType ===
												  'youth-followup' ? (
													<>
														<br />
														<br />
														<b>
															strings.youthfollowuptest
														</b>
													</>
												) : this.state.testType ===
												  'child-followup' ? (
													<>
														<b>
															<br />
															<br />

															{
																strings.childfollowuptest
															}
														</b>
													</>
												) : (
													<>
														<br />
														<br />
														<b>
															{
																strings.adultfollowuptest
															}
														</b>
													</>
												)
											)
										: this.state.showReportTab
											? strings.formatString(
													strings.dynamicheaderfortestreport_child,
													this.state.testType ===
														'child' ? (
														<b>
															{strings.childtest}
														</b>
													) : this.state.testType ===
													  'youth-followup' ? (
														<>
															<br />
															<br />
															<b>
																{
																	strings.youthfollowuptest
																}
															</b>
														</>
													) : this.state.testType ===
													  'child-followup' ? (
														<>
															<br />
															<br />
															<b>
																{
																	strings.childfollowuptest
																}
															</b>
														</>
													) : (
														<>
															<br />
															<br />
															<b>
																{
																	strings.adultfollowuptest
																}
															</b>
														</>
													)
												)
											: ''}
						</h1>
						<div>
							{!this.state.showHandBookTab &&
								this.state.showReportTab &&
								!this.state.showTestUserInfo && (
									<>
										<br />

										<span className="lit-printed-by">
											{strings.administratorLabel}
										</span>
										<b style={{marginLeft: '4px'}}>
											{ownerFullName}
										</b>
										{!isCommon && (
											<>
												<span className="lit-printed-by">
													{strings.savedByLabel}
												</span>
												<b style={{marginLeft: '4px'}}>
													{adminCompleteName}
												</b>
											</>
										)}
									</>
								)}
						</div>
						{!this.state.showHandBookTab && (
							<p className="lit-page-lead">
								{strings.formatString(
									this.state.showResultsTab
										? strings.newinfo_belowpresentsinformation
										: this.state.showTestUserInfo
											? strings.newinfo3_belowpresentsinformation
											: this.state.showReportTab
												? newinfo2BelowpresentsInformation
												: '',

									<>
										<br />
										<b>{completeName}</b>
										<br />{' '}
									</>,

									<span>
										{strings.born}
										<b>{birthDate}</b>
									</span>,
									<span>
										{this.returnTestUserGrade(
											testUser,
											notAvailable
										)}
									</span>
								)}
								{testResult.completedAt ? (
									strings.formatString(
										infoTestWasCompletedOn,
										<>
											<b>
												{moment(
													testResult.completedAt
												).format('DD.MM.YYYY')}
												.
											</b>
											<br />
										</>
									)
								) : (
									<>
										<br />
										{
											strings.info_testwasNotcompletedon
										}{' '}
										<br />
									</>
								)}
								{strings.formatString(
									inforScrAgeAtCommencement,
									<b>{testUser.age.years}</b>,

									<b>{testUser.age.months}</b>
								)}
								<br />
								Språkstatus: <b>{languageStatus}</b>
							</p>
						)}
					</div>

					<div className="lit-tab-wrapper">
						<div className="lit-results-line" />
						{this.state.buttonTabs.map((tab, index) => {
							const id = tab.id;
							const value = tab.value;
							const buttonClass = tab.buttonClass;
							const btnText = tab.text;

							// eslint-disable-next-line react/jsx-key
							return (
								<button
									className={buttonClass}
									id={id}
									key={index}
									value={value}
									disabled={buttonClass.includes('active')}
									onClick={(e) => {
										this.setRelevantTab(
											e.target.value,
											index
										);
									}}
								>
									{btnText}
								</button>
							);
						})}
					</div>

					{this.state.showResultsTab &&
						!this.state.showReportTab &&
						!this.state.showInformationTab && (
							<div className="lit-histogram-Test_Details">
								<div className="lit-printBtn">
									<button
										className={classNames('print-hide', {
											'lit-btn2 see-more': true,
											'bg-tertiary': true,
										})}
										onClick={() => {
											window.print();
											this.updatePrintLog('Results');
										}}
									>
										<FontAwesomeIcon
											size="lg"
											className="lit-icon-btns"
											icon={faPrint}
										/>

										<p className="lit-btns-txt">
											{strings.formatString(
												strings.testresult
											)}
										</p>
									</button>
								</div>
								<div className="lit-results-background">
									<div className="sub-test total print-summary">
										{!testResult.completedAt && (
											<div className="incomplete-notice">
												{strings.incompleteMessage}
											</div>
										)}
										<h3 className="sub-test__name big">
											{strings.formatString(
												strings.summary,
												'resultater'
											)}
										</h3>
										<div className="summary-chart">
											<HorizontalBarChart
												isChild
												subtests={subtestsToBeRendered}
											/>
										</div>
										<div className="explanations">
											<div className="explanation">
												<div className="explanation__figure negative" />
												<p className="explanation__text">
													{strings.formatString(
														zscorered,
														<em>{strings.under}</em>
													)}
												</p>
											</div>
											<div className="explanation">
												<div className="explanation__figure neutral" />
												<p className="explanation__text">
													{zscoreblue}
												</p>
											</div>
											<div className="explanation">
												<div className="explanation__figure positive" />
												<p className="explanation__text">
													{strings.formatString(
														zscoregreen,
														<em>{strings.over}</em>
													)}
												</p>
											</div>
										</div>
										{this.state.testType === 'child' &&
											!this.state.isInKinderGarten && (
												<div className="sub-test__scores">
													<div className="width--half center">
														<h4 className="sub-test__heading big">
															{strings.assessment}
														</h4>

														{writeUpText.map(
															(text, key) => {
																return (
																	<p
																		key={
																			key
																		}
																	>
																		{text}
																	</p>
																);
															}
														)}
													</div>
												</div>
											)}
									</div>
									<div className="print-sub-tests">
										{subtestsToBeRendered.map((subtest) => {
											return this.renderSubtest(subtest);
										})}
										{[
											'child-followup',
											'youth-followup',
											'adult-followup',
										].includes(this.state.testType) &&
											writeUpText.length > 0 && (
												<div className="lit-results-assessment">
													<div className="sub-test__scores">
														<div className="width--half center">
															<h4 className="sub-test__heading big">
																{
																	strings.assessment
																}
															</h4>

															{writeUpText.map(
																(text, key) => {
																	return (
																		<p
																			key={
																				key
																			}
																		>
																			{
																				text
																			}
																		</p>
																	);
																}
															)}
														</div>
													</div>
												</div>
											)}
									</div>
								</div>
							</div>
						)}
					{showTestUserInfo && (
						<TestUserInfo
							testResult={testResult}
							testReportLang={testReportLang}
						/>
					)}
					{this.state.showReportTab &&
						!this.state.showTestUserInfo && (
							<div className="lit-histogram-Test_Report">
								<div className="lit-printBtn">
									<button
										className={classNames('print-hide', {
											'lit-btn2 see-more': true,
											'bg-tertiary': true,
										})}
										onClick={() => {
											this.updatePrintLog('Report');
											this.setState({reportNotes: ''});
											this.toggleAddNotesModal();
										}}
									>
										<FontAwesomeIcon
											size="lg"
											className="lit-icon-btns"
											icon={faPrint}
										/>

										<p className="lit-btns-txt">
											{strings.formatString(
												strings.printwithcomment,
												strings.testreport
											)}
										</p>
									</button>
									<button
										className="lit-mytests-header-mytest-btn-primary"
										onClick={() => {
											this.onClickTranslateReport();
										}}
									>
										<FontAwesomeIcon
											size="lg"
											className="lit-icon-btns"
											icon={faLanguage}
										/>

										<p className="lit-btns-txt">
											{testReportLang === 'nn'
												? strings._props.nn
														.translateToNorsk
												: strings.translateToNynorsk}
										</p>
									</button>
									{this.state.showAlert && (
										<AlertBox
											type={
												this.state.success
													? 'success'
													: 'error'
											}
											message={this.state.message}
										/>
									)}
								</div>
								<div className="lit-results-background">
									<div className="sub-test total print-summary">
										{!testResult.completedAt && (
											<div className="incomplete-notice">
												{strings.incompleteMessage}
											</div>
										)}

										<ReportIntroduction
											testType={this.state.testType}
											testResult={testResult}
											testReportLang={
												this.state.testReportLang
											}
											useDysmate2Handbook
										/>

										<h3 className="sub-test__name big">
											{strings.formatString(
												strings.summary,
												strings.testreport
											)}
										</h3>
										<div className="summary-chart">
											<HorizontalBarChart
												isChild
												subtests={subtestsToBeRendered}
											/>
										</div>
										<div className="explanations">
											<div className="explanation">
												<div className="explanation__figure negative" />
												<p className="explanation__text">
													{strings.formatString(
														zscorered,
														<em>{strings.under}</em>
													)}
												</p>
											</div>
											<div className="explanation">
												<div className="explanation__figure neutral" />
												<p className="explanation__text">
													{zscoreblue}
												</p>
											</div>
											<div className="explanation">
												<div className="explanation__figure positive" />
												<p className="explanation__text">
													{strings.formatString(
														zscoregreen,
														<em>{strings.over}</em>
													)}
												</p>
											</div>
										</div>

										<div className="print-sub-tests-report">
											{subtestsToBeRendered.map(
												(subtest) => {
													return this.renderSubtestReport(
														subtest
													);
												}
											)}
										</div>
										<br />

										<div>
											{(this.state.testType !== 'child' ||
												this.state.isInKinderGarten) &&
												(![
													'youth-followup',
													'adult-followup',
													'child-followup',
												].includes(
													this.state.testType
												) ||
													writeUpText.length > 0) && (
													<div className="sub-test__scores">
														<div className="width--half center">
															<h4 className="sub-test__heading big">
																{
																	strings.assessment
																}
															</h4>

															{writeUpText.map(
																(text) => {
																	return (
																		<p>
																			{
																				text
																			}
																		</p>
																	);
																}
															)}
														</div>
													</div>
												)}
											<br />
											{reportNotes && (
												<>
													<div className="sub-test__comment-page-breaker" />
													<div className="sub-test__comment">
														<h4 className="sub-test__heading big">
															<span className="comment">
																{
																	strings.commentsLabel
																}
															</span>
															<p className="report-notes">
																{reportNotes}
															</p>
															<div className="line-one-text">
																{
																	strings.commentWrittenByAdministrator
																}{' '}
																{ownerFullName}
															</div>
															<div className="line-container">
																<div className="line line-1" />
															</div>
														</h4>
													</div>
												</>
											)}
										</div>
									</div>
								</div>
							</div>
						)}
					{this.state.showHandBookTab && (
						<HandBook
							useDysmate2Handbook
						/>
					)}
					{this.state.showAddNotesModal && (
						<AddNotesModal
							showModal={this.state.showAddNotesModal}
							toggleModal={this.toggleAddNotesModal}
							reportNotes={reportNotes}
							setReportNotes={(notes) => {
								this.setState({reportNotes: notes});
							}}
						/>
					)}
				</div>
			</div>
		);
	}
}

SingleChildTest.propTypes = {
	currentUser: PropTypes.shape({}),
};

const mapStateToProps = (state) => {
	const {currentUser} = state;

	return {
		currentUser,
	};
};

const mapDispatchToProps = {};

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(SingleChildTest)
);
